var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmoticonExcited({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 45,
    viewBox: "0 0 42 45",
    fill: "#4985DF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0438 0.416626C9.51405 0.416626 0.17749 10.2879 0.17749 22.5C0.17749 34.712 9.51405 44.5833 21.0438 44.5833C32.5735 44.5833 41.9518 34.712 41.9518 22.5C41.9518 10.2879 32.5944 0.416626 21.0438 0.416626ZM21.0646 40.1666C11.8325 40.1666 4.35492 32.2608 4.35492 22.5C4.35492 12.7391 11.8325 4.83329 21.0646 4.83329C30.2968 4.83329 37.7744 12.7391 37.7744 22.5C37.7744 32.2608 30.2968 40.1666 21.0646 40.1666ZM23.1534 17.9508L25.3674 20.2916L27.5814 17.9508L29.7955 20.2916L32.0095 17.9508L27.5814 13.2691L23.1534 17.9508ZM14.5479 17.9508L16.7619 20.2916L18.9759 17.9508L14.5479 13.2691L10.1198 17.9508L12.3338 20.2916L14.5479 17.9508ZM21.0646 34.6458C25.9314 34.6458 30.067 31.4216 31.738 26.9166H10.3913C12.0623 31.4216 16.1979 34.6458 21.0646 34.6458Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoticonExcited);
export default __webpack_public_path__ + "static/media/emoticon-excited.be0effc4.svg";
export { ForwardRef as ReactComponent };